/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Text, Theme, useTheme } from 'bold-ui'
import { Box } from 'components/Box'
import { RadioGroupField, RadioGroupFieldProps } from 'components/form'
import { ReactNode } from 'react'

export interface PerguntaRadioGroupBoxFieldProps<T extends string | number | string[]>
  extends Omit<RadioGroupFieldProps<T>, 'label'> {
  label: string | ReactNode
}

export function PerguntaRadioGroupBoxField<T extends string | number | string[]>(
  props: Readonly<PerguntaRadioGroupBoxFieldProps<T>>
) {
  const { label, required, ...rest } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Box style={styles.box}>
      <HFlow alignItems='center' justifyContent='space-between'>
        <Text>
          <Text style={styles.text}>“{label}”</Text>
          {required && <Text color='danger'> *</Text>}
        </Text>
        <RadioGroupField hSpacing={0.5} required={required} {...rest} />
      </HFlow>
    </Box>
  )
}

const createStyles = (theme: Theme) => ({
  box: css`
    padding: 0.75rem 1rem;
  `,
  text: css`
    color: ${theme.pallete.primary.main};
    font-weight: bold;
  `,
})
